import { FPageVideoBlock } from '../mdl/f-page-block';
import { $el } from '../ui/elements';
import { uiIsMedia } from '../ui/media';
import { $cdn } from '../y/cdn';
import { blkRegister } from './registry';

blkRegister<FPageVideoBlock>('video', _b => {
    const video_elem = $el.create('video');
    video_elem.controls = true;
    video_elem.muted = true;
    video_elem.autoplay = true;
    video_elem.loop = true;

    if(uiIsMedia('m')) {
        video_elem.poster = $cdn('videos/how-mobile-poster.2.webp');
        const source_mp4 = $el.create('source');
        source_mp4.src = $cdn('videos/how-mobile.2.mp4');
        source_mp4.type = 'video/mp4';
        video_elem.appendChild(source_mp4);
        const source_webm = $el.create('source');
        source_webm.src = $cdn('videos/how-mobile.2.webm');
        source_webm.type = 'video/webm';
        video_elem.appendChild(source_webm);
    } else {
        video_elem.poster = $cdn('videos/how-desktop-poster.2.webp');
        const source_mp4 = $el.create('source');
        source_mp4.src = $cdn('videos/how-desktop.2.mp4');
        source_mp4.type = 'video/mp4';
        video_elem.appendChild(source_mp4);
        const source_webm = $el.create('source');
        source_webm.src = $cdn('videos/how-desktop.2.webm');
        source_webm.type = 'video/webm';
        video_elem.appendChild(source_webm);
    }

    return $el.DIV('blk-video b b-content w-block', video_elem);
})
